import graphql__fb7d2e788660e5963f58 from "./__generated__/ContributionModalLinkedContributions_contribution.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import LinkedContribution from "./LinkedContribution";
import Icon from "../../Utils/Icon";
import { useFormatMessage } from "../../Intl/Context";

const ContributionModalLinkedContributions = props => {
  const contribution = useFragment(
    ContributionModalLinkedContributions_contribution,
    props.contribution
  );

  const { linkedContributions, theme } = contribution;
  const hasLinkedContributions = linkedContributions.length > 0;

  const t = useFormatMessage();
  const linkedContributionsLabel = t(intlMessages.linkedContributions, {
    count: linkedContributions.length
  });

  // If there's no linked contributions, don't display the block at all
  if (!hasLinkedContributions) return null;

  return (
    <>
      <div className="box bg-primary text-primary-inverse margin-top-xs d-flex align-items-center">
        <Icon className="icon-pencil align-middle margin-right-sm" />
        <h3 className="text-default">{linkedContributionsLabel}</h3>
      </div>

      <div className="linked-contributions modal-buttons-container">
        {linkedContributions.map(linkedContribution => (
          <LinkedContribution
            key={linkedContribution.id}
            contribution={linkedContribution}
            parentContributionTheme={theme}
          />
        ))}
      </div>
    </>
  );
};

const ContributionModalLinkedContributions_contribution = graphql__fb7d2e788660e5963f58;

export default ContributionModalLinkedContributions;

const intlMessages = defineMessages({
  linkedContributions: {
    id: "contributions.modal.linkedContributions",
    defaultMessage:
      "{count, plural, one { 1 contribution en lien } other {{count} contributions en lien}}"
  }
});
